// GENERATED COPY. Edit shared/security only; policyParity.test.ts enforces parity.
/**
 * @fileoverview Common passwords for the blocklist rule of `passwordPolicy`.
 *
 * Two lists, because they are compared differently:
 *
 * - `COMMON_PASSWORDS`: whole passwords, as they appear in the public lists of
 *   the most used and leaked ones. Compared lower-cased and without accents.
 * - `COMMON_BASE_WORDS`: the base word of the ones that satisfy the composition
 *   rules only thanks to decoration. «P@ssw0rd123!» and «Welcome1!» have an
 *   uppercase letter, a number and a symbol, but they are `password` and
 *   `welcome` with a number and a symbol attached. Compared against the core of
 *   the password: without the digits and symbols at both ends and with the
 *   leetspeak undone (@→a, 0→o, 1→i, 3→e, $→s…). Only the whole core counts:
 *   «Summer2025!Beach» is not `summer`.
 *
 * The lists do not try to cover what Have I Been Pwned covers (the web app
 * checks it too, by k-anonymity): only what repeats the most.
 *
 * Mirrors `src/data/commonPasswords.ts` of the Design prototype, and is copied
 * verbatim to `app/src/features/password-policy/policy/` (see `passwordPolicy`).
 *
 * @module shared/security/commonPasswords
 */

export const COMMON_PASSWORDS: ReadonlySet<string> = new Set([
  '123456',
  '123456789',
  '12345678',
  '12345',
  '1234567',
  '1234567890',
  '123123',
  '111111',
  '000000',
  '654321',
  '666666',
  '121212',
  '112233',
  '123321',
  '987654321',
  'password',
  'password1',
  'password12',
  'password123',
  'password1234',
  'passw0rd',
  'p@ssw0rd',
  'p@ssword',
  'pa$$w0rd',
  'pa$$word',
  'password!',
  'password1!',
  'qwerty',
  'qwerty1',
  'qwerty12',
  'qwerty123',
  'qwertyuiop',
  '1q2w3e4r',
  '1q2w3e4r5t',
  '1qaz2wsx',
  'zaq12wsx',
  'qazwsx',
  'asdfgh',
  'asdfghjkl',
  'zxcvbnm',
  'abc123',
  'abcd1234',
  'a1b2c3',
  'a1b2c3d4',
  'aa123456',
  'iloveyou',
  'iloveyou1',
  'letmein',
  'letmein1',
  'welcome',
  'welcome1',
  'welcome123',
  'admin',
  'admin123',
  'admin1234',
  'administrator',
  'root',
  'toor',
  'guest',
  'test',
  'test123',
  'changeme',
  'default',
  'secret',
  'login',
  'master',
  'monkey',
  'dragon',
  'football',
  'baseball',
  'sunshine',
  'princess',
  'shadow',
  'superman',
  'batman',
  'trustno1',
  'whatever',
  'freedom',
  'starwars',
  'pokemon',
  'hello123',
  'charlie',
  'michael',
  'jordan23',
  'liverpool',
  'chelsea',
  'arsenal',
  'barcelona',
  'realmadrid',
  'contrasena',
  'contrasena1',
  'teamo',
  'teamo123',
  'bienvenido',
  'bienvenida',
  'mexico',
  'mexico123',
  'hola123',
  'holamundo',
]);

export const COMMON_BASE_WORDS: ReadonlySet<string> = new Set([
  'password',
  'passwort',
  'qwerty',
  'welcome',
  'admin',
  'administrator',
  'letmein',
  'iloveyou',
  'monkey',
  'dragon',
  'football',
  'baseball',
  'soccer',
  'sunshine',
  'princess',
  'master',
  'shadow',
  'superman',
  'batman',
  'spiderman',
  'trustno',
  'whatever',
  'freedom',
  'hello',
  'login',
  'secret',
  'changeme',
  'default',
  'guest',
  'test',
  'user',
  'root',
  'starwars',
  'pokemon',
  'naruto',
  'charlie',
  'michael',
  'jordan',
  'hunter',
  'ranger',
  'killer',
  'lovely',
  'flower',
  'angel',
  'family',
  'loveme',
  'jesus',
  'blessed',
  'cookie',
  'chocolate',
  'computer',
  'internet',
  'google',
  'facebook',
  'samsung',
  'summer',
  'winter',
  'spring',
  'autumn',
  'liverpool',
  'chelsea',
  'arsenal',
  'barcelona',
  'realmadrid',
  'company',
  'office',
  'access',
  'security',
  'system',
  'server',
  'support',
  'service',
  'manager',
  'contrasena',
  'teamo',
  'amor',
  'hola',
  'holamundo',
  'bienvenido',
  'bienvenida',
  'mexico',
  'america',
  'cruzazul',
  'chivas',
  'pumas',
]);
